import React, { useContext, useState, useEffect } from 'react';
import { RicosContext, ModalContext, EditorContext } from 'ricos-context';
import { LinkModal } from 'wix-rich-content-toolbars-modals';
import { LINK_PREVIEW_TYPE } from '../types.js';
import { linkPreviewModals } from '../consts.js';
import { isEmpty } from 'lodash';
import 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const LinkPreviewSettingsModal = ({ nodeId, uiSettings }) => {
  const { t, isMobile } = useContext(RicosContext);
  const modalService = useContext(ModalContext) || {};
  const { getEditorCommands } = useContext(EditorContext);
  const [initialData, setInitialData] = useState();
  const [componentData, setComponentData] = useState();
  useEffect(() => {
    const componentData2 = getEditorCommands().getBlockComponentData(nodeId);
    setInitialData(componentData2);
    setComponentData(componentData2);
  }, []);
  const updateData = (data) => {
    getEditorCommands().setBlock(nodeId, LINK_PREVIEW_TYPE, __spreadProps(__spreadValues(__spreadValues({}, componentData), data), {
      id: nodeId
    }));
    setComponentData(__spreadValues(__spreadValues({}, componentData), data));
  };
  const { url, target = "BLANK", rel = {} } = (componentData == null ? void 0 : componentData.link) || {};
  const getRelString = (rel2) => {
    if (isEmpty(rel2)) {
      return "noopener noreferrer";
    } else {
      return `${rel2.noreferrer ? "noreferrer" : ""} ${rel2.noopener ? "noopener" : ""} ${rel2.nofollow ? "nofollow" : ""} ${rel2.sponsored ? "sponsored" : ""}`;
    }
  };
  const getRelObject = (rel2 = "") => {
    const relArray = rel2.split(" ");
    const relObject = {};
    relArray.forEach((rel3) => relObject[rel3] = true);
    return relObject;
  };
  const closeModal = () => {
    modalService.closeModal(linkPreviewModals.settings);
  };
  const onCancel = () => {
    updateData(initialData);
    closeModal();
  };
  const onDone = ({ data: { url: url2, target: target2, rel: rel2 } }) => {
    const newComponentData = __spreadProps(__spreadValues({}, componentData), {
      link: __spreadProps(__spreadValues({}, componentData == null ? void 0 : componentData.link), {
        url: url2,
        target: target2.substring(1).toUpperCase(),
        rel: getRelObject(rel2)
      })
    });
    updateData(newComponentData);
    closeModal();
  };
  return componentData ? /* @__PURE__ */ React.createElement(
    LinkModal,
    {
      hideUrlInput: true,
      anchorTarget: `_${target.toLowerCase()}`,
      uiSettings,
      relValue: getRelString(rel),
      t,
      onCancel,
      onDone,
      isMobile,
      isActive: true,
      url
    }
  ) : null;
};

export { LinkPreviewSettingsModal as default };
//# sourceMappingURL=SettingsModal.js.map
